module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/closet-de2d84aa5a3a57bb9eb51f21c6851f51.svg";